import React from 'react'
import './style.css'
import { Minus, Plus } from '@phosphor-icons/react'

export default function FontSize({value, setValue}) {
  return (
    <div className='FontSize'>
        <button onClick={()=>setValue(value - 1)}>
            <Minus weight='bold'/>
        </button>
        <input onKeyDown={(e)=> e.stopPropagation()} value={value || ""} onChange={(e)=>setValue(parseInt(e?.target?.value))}/>
        <button onClick={()=>setValue(value + 1)}>
            <Plus weight='bold'/>
        </button>
    </div>
  )
}
